import { render, staticRenderFns } from "./ContestedLossList.vue?vue&type=template&id=29f389f6&scoped=true"
import script from "./ContestedLossList.vue?vue&type=script&lang=js"
export * from "./ContestedLossList.vue?vue&type=script&lang=js"
import style0 from "./ContestedLossList.vue?vue&type=style&index=0&id=29f389f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f389f6",
  null
  
)

export default component.exports